import { useMemo } from 'react'
import {
  useRecurrenceDispatch,
  useRecurrencePeriod,
  useRecurrenceType,
} from '../../../providers/StateProvider'
import { useTexts } from './useTexts'

export function useRecurrencePeriodProps() {
  const type = useRecurrenceType()
  const value = useRecurrencePeriod()
  const dispatch = useRecurrenceDispatch()
  const texts = useTexts()

  return useMemo(
    () => ({
      label: texts.label,
      info: texts.info(value, type as uui.domain.client.rm.RecurrenceType),
      value,
      onChange: (recurrencePeriod: number) => {
        dispatch({
          type: 'recurrencePeriod:change',
          recurrencePeriod,
        })
      },
      testId: 'RecurrencePeriod',
      trackId: 'RecurrencePeriod',
    }),
    [texts, value, type, dispatch],
  )
}
